module.exports = __webpack_public_path__ + "img/NUlfhednar64_ua.c1726a5e.webp";